class Careers {
    constructor() {
 
      jQuery(document).on('gform_post_render', function(event, form_id, current_page){
 
          // Careers detail page
          if (window.location.pathname.startsWith('/careers/') && !window.location.pathname.endsWith('/careers/')) {

            let jobTitleField = document.querySelector('.gform_hidden[value="General Careers Enquiry"]');
            console.log("jobTitleField", jobTitleField)
            let jobTitle = document.querySelector('.careers-page h1');
            if (jobTitleField && jobTitle){
              jobTitleField.value = jobTitle.innerText;
            }

            let jobURLField = document.querySelector('.gform_hidden[value="https://mspcapital.co.uk/careers/"]');
            if (jobURLField){
              jobURLField.value = window.location.href;
            }
          }
  
      });

    }
  }
  
  export default new Careers;
  